/*
 * @Author: zhaotao
 * @Version: 
 * @Date: 2023-04-04 10:17:19
 * @Description: 
 */
import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';

export default (function (params) {
  const { data, exec } = useRequest({
    url: '',
    name: 'GET_CAPACITY_ANALYSIS',
    manual: true,
  });

  useEffect(() => {
    if (params.id === '' || params.id === undefined || params.start === '' || params.end === '') {
    } else {
      let url = `/api/capacity/analysis/${params.id}`;
      Object.keys(params).forEach((key, index) => {
        if (index === 0) url += '?';
        else url += '&';
        url += `${key}=${params[key]}`;
      });
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  return data || [];
});
